import { Subject } from 'rxjs';

import { Component, Input } from '@angular/core';

@Component({
  standalone: false,
  selector: 'phoenix-expandable-button',
  templateUrl: './expandable-button.component.html',
})
export class ExpandableButtonComponent {
  @Input({ required: true }) ariaLabel = '';
  @Input() buttonTitle = '';
  @Input() expanded = false;

  destroy$ = new Subject<void>();
  opened = false;

  toggleExpand(): void {
    this.expanded = !this.expanded;
  }
}
